/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsonlyflagged2Inputs */

const en_signupsonlyflagged2 = /** @type {(inputs: Signupsonlyflagged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only flagged`)
};

const de_signupsonlyflagged2 = /** @type {(inputs: Signupsonlyflagged2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur markierte`)
};

/**
* | output |
* | --- |
* | "Only flagged" |
*
* @param {Signupsonlyflagged2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsonlyflagged2 = /** @type {((inputs?: Signupsonlyflagged2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsonlyflagged2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsonlyflagged2(inputs)
	return de_signupsonlyflagged2(inputs)
});
export { signupsonlyflagged2 as "signupsOnlyFlagged" }